import { useQuery } from '@tanstack/vue-query'

import { getPropertyOwnerKycList } from '../propertyOwnersEndpoints'
import { ownersQueryKeys } from '../propertyOwnersQueryKeys'
import type { GetPropertyOwnerKycListParams } from '../../types/propertyOwnerTypes'
import { KYC_ACTIONABLE_STATUSES } from '../../constants/propertyOwnerKyc'

// KYC / KYB review queue size for the sidebar badge. The PO module has no
// dedicated count endpoint, so we reuse the queue's list endpoint and read its
// `total`. limit:1 keeps the payload tiny — we only need the count.
//
// Deliberately counts ONLY the actionable statuses, even though the review
// screen can now also show approved and rejected rows. The badge is a to-do
// count; widening it to every settled submission would make it permanently
// large and therefore ignored.
const KYC_REVIEW_COUNT_PARAMS: GetPropertyOwnerKycListParams = {
  kycStatus: [...KYC_ACTIONABLE_STATUSES],
  page: 1,
  limit: 1,
}

export function usePropertyOwnerKycReviewCountQuery() {
  return useQuery({
    queryKey: ownersQueryKeys.kycList(KYC_REVIEW_COUNT_PARAMS),
    queryFn: () => getPropertyOwnerKycList(KYC_REVIEW_COUNT_PARAMS),
    select: (res) => res.total,
  })
}
